import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateTimePicker from '@components/common/date_time_picker/main';
import AccordionSection from './accordionSection';

class DateFilter extends React.Component {
  state = {
    created_at_startDate: moment().subtract(7, 'days').format('MM/DD/YYYY'),
    created_at_endDate: moment().format('MM/DD/YYYY'),
    created_at_range:
      `[${moment().subtract(7, 'days').format('YYYY-MM-DD')} TO ${moment().format('YYYY-MM-DD')}]`
  };

  updateDateStart = (selectedStartDate) => {
    this.updateDateRange(selectedStartDate, 'start');
  }

  updateDateEnd = (selectedEndDate) => {
    this.updateDateRange(selectedEndDate, 'end');
  }

  updateUploadDate(uploadDate) {
    if (uploadDate === 'range') {
      uploadDate = this.state.created_at_range; // eslint-disable-line no-param-reassign
    }

    this.props.updateFilters(uploadDate);
  }

  updateDateRange(selectedDate, whichDate) {
    let startDate = '';
    let startDateSearch = '';
    let endDate = '';
    let endDateSearch = '';

    if (whichDate === 'start') {
      startDate = moment(selectedDate).format('MM/DD/YYYY');
      startDateSearch = moment(selectedDate).format('YYYY-MM-DD');
      endDate = this.state.created_at_endDate;
      endDateSearch = moment(this.state.created_at_endDate).format('YYYY-MM-DD');
    } else if (whichDate === 'end') {
      endDate = moment(selectedDate).format('MM/DD/YYYY');
      endDateSearch = moment(selectedDate).format('YYYY-MM-DD');
      startDate = this.state.created_at_startDate;
      startDateSearch = moment(this.state.created_at_startDate).format('YYYY-MM-DD');
    }

    if (moment(startDate).isSameOrBefore(moment(endDate))) {
      const dateRange = `[${startDateSearch} TO ${endDateSearch}]`;

      this.props.updateFilters(dateRange);
      this.setState({
        created_at_startDate: startDate,
        created_at_endDate: endDate,
        created_at_range: dateRange
      });
    }
  }

  render() {
    const { createdDate } = this.props;

    return (
      <AccordionSection overflowContent title={bfTranslate("Upload Date")}>
        <React.Fragment>
          <div className="flex-row radio-container">
            <input
              id="created-at-all-time-search"
              type="radio"
              name="all time"
              value=""
              checked={createdDate === null}
              onChange={() => this.updateUploadDate(null)}
            />
            <label htmlFor="created-at-all-time-search">{bfTranslate('All')}</label>
            <span className="radio-dot" />
          </div>
          <div className="flex-row radio-container">
            <input
              id="created-at-30-minute-search"
              type="radio"
              name="created_at"
              value=">now-30m"
              checked={createdDate === ">now-30m"}
              onChange={() => this.updateUploadDate(">now-30m")}
            />
            <label htmlFor="created-at-1-day-search">{bfTranslate('Last 30 minutes')}</label>
            <span className="radio-dot" />
          </div>
          <div className="flex-row radio-container">
            <input
              id="created-at-1-day-search"
              type="radio"
              name="created_at"
              value=">now-1d"
              checked={createdDate === ">now-1d"}
              onChange={() => this.updateUploadDate(">now-1d")}
            />
            <label htmlFor="created-at-1-day-search">{bfTranslate('Past 24 hours')}</label>
            <span className="radio-dot" />
          </div>
          <div className="flex-row radio-container">
            <input
              id="created-at-7-days-search"
              type="radio"
              name="created_at"
              value=">now-7d"
              checked={createdDate === ">now-7d"}
              onChange={() => this.updateUploadDate(">now-7d")}
            />
            <label htmlFor="created-at-7-days-search">{bfTranslate('Past 7 days')}</label>
            <span className="radio-dot" />
          </div>
          <div className="flex-row radio-container">
            <input
              id="created-at-range"
              type="radio"
              name="created_at"
              value="range"
              checked={createdDate !== null
                        && this.props.createdDate.indexOf('TO') > -1}
              onChange={() => this.updateUploadDate('range')}
            />
            <label htmlFor="created-at-range">{bfTranslate('Date range')}</label>
            <span className="radio-dot" />
          </div>
          <div className={`flex-row date-range-picker-container ${createdDate
                            && createdDate.indexOf('TO') > -1 ? 'active' : ''}`}
          >
            <div className="range-start">
              <h4>{bfTranslate('From')}:</h4>
              <DateTimePicker
                selectedDate={this.state.created_at_startDate}
                allowPastDates
                updateDateTime={this.updateDateStart}
              />
            </div>
            <div className="range-end">
              <h4>{bfTranslate('To')}:</h4>
              <DateTimePicker
                selectedDate={this.state.created_at_endDate}
                allowPastDates
                updateDateTime={this.updateDateEnd}
              />
            </div>
          </div>
        </React.Fragment>
      </AccordionSection>
    );
  }
}

DateFilter.propTypes = {
  createdDate: PropTypes.string,
  updateFilters: PropTypes.func.isRequired,
};

DateFilter.defaultProps = {
  createdDate: null,
};

export default DateFilter;
